import { render } from "./ControlPanelAdd.vue?vue&type=template&id=58d37028"
import script from "./ControlPanelAdd.vue?vue&type=script&lang=js"
export * from "./ControlPanelAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__